import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAsyncFn } from 'react-use/lib';
import { getPageMetaData, updatePageMetaData, updateUrls } from 'redux/content';
import { fetchGetPageMetaData } from 'services/networking/navigation';

var usePageMetaData = function usePageMetaData(contentId) {
  var dispatch = useDispatch();

  var _useSelector = useSelector(getPageMetaData),
      pageMetaData = _useSelector.value,
      loading = _useSelector.loading;

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fetchedMetaData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch(updatePageMetaData({
              loading: true
            }));
            dispatch(updateUrls({
              loading: true
            }));
            _context.next = 4;
            return fetchGetPageMetaData(contentId);

          case 4:
            fetchedMetaData = _context.sent;
            dispatch(updatePageMetaData({
              value: fetchedMetaData
            }));
            dispatch(updateUrls({
              value: fetchedMetaData
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [contentId, dispatch]),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      error = _useAsyncFn2[0].error,
      fetchPageMetaData = _useAsyncFn2[1]; // Re-initialize content in store to avoid overwriting while editing a new one


  useEffect(function () {
    dispatch(updatePageMetaData({
      value: undefined,
      loading: false
    }));
    dispatch(updateUrls({
      value: undefined,
      loading: false
    }));
  }, [dispatch]);
  useEffect(function () {
    if (error) {
      dispatch(updatePageMetaData({
        loading: false
      }));
      dispatch(updateUrls({
        loading: false
      }));
    }
  }, [dispatch, error]); // For fetching metaData the first time

  useEffect(function () {
    void fetchPageMetaData();
  }, [fetchPageMetaData]);
  return {
    pageMetaData: pageMetaData,
    loading: loading,
    fetchPageMetaData: fetchPageMetaData
  };
};

export default usePageMetaData;